export * from './reducers';
export * from './effects';
export * from './actions';
export * from './selectors';

export function getSelectedOpinion(getSelectedOpinion: any): import('rxjs').ObservableInput<any> {
  throw new Error('Function not implemented.');
}
